import { IAvailablePlanNames } from 'client/components/Subscription/PremiumPlans/IPremiumInterface'

import { QuotaTypes } from './SubscriptionInterface'

export type BillingCycleOption = 'month' | 'year'
export enum SubscriptionBillingCycleOptionEnums {
  month = 'month',
  year = 'year',
}

export interface SubscriptionPlanInterface {
  readonly id: string
  readonly name: IAvailablePlanNames
  readonly price: number
  readonly description?: string
  readonly quotas: PlanQuotaInterface[]
  readonly currency: string
  readonly freeTrialDays?: number
  readonly countyCode: string
  readonly billingCycle: BillingCycleOption
}

export interface PlanQuotaInterface {
  readonly name: QuotaTypes
  readonly quota: number
  readonly description?: string
  readonly unit?: string
}
